const datamanagernpscsat = (state = [], action) => {
    switch (action.type) {
      case 'HANDLE_DATA_CSAT_NPS':
        return action.data
      default:
        return state
    }
  }
  
  export default datamanagernpscsat